import { MultilineInput, Ref, RefBool } from "@tblabs/truffle";


export class JsonEditor extends MultilineInput
{
    public IsValid = new RefBool();

    constructor(ref: Ref<string>, rows: number = 12)
    {
        super(ref);
        this.Rows(rows);

        ref.OnChange(async (value) =>
        {
            try
            {
                JSON.parse(value);
                this.BorderColor("#29a729").Background("#fcfcfc");
                this.IsValid.value = true;
            } 
            catch (ex: any)
            {
                this.BorderColor("red").Background("#ffe7e7");
                this.IsValid.value = false;
            }
        }, true);
    }
}
